/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppTypeEnum } from './oAuthAppTypeEnum';
import { OAuthAppRotationTypeEnum } from './oAuthAppRotationTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface OAuthAppRotateSecretSpec { 
    rotation_type: OAuthAppRotationTypeEnum;
    app_id?: string;
    org_id?: string;
    service_type?: ServiceTypeEnum;
    /**
     * OAuth app type to be rotated.
     */
    app_type?: Array<OAuthAppTypeEnum>;
}
export namespace OAuthAppRotateSecretSpec {
}


